export const modalVisibilityActions = {
  open: 'OPEN_MODAL/',
  close: 'CLOSE_MODAL/',
}
